/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useRef} from 'react';
import {Platform} from 'react-native';

import InfoPopover from '/component/partial/InfoPopover';
import {ORDER_DETAILS} from '/enum/records.enum';

import {MainScreen} from './MainScreen';
import {ReportScreen} from './ReportScreen';

export function getReportScreenComponent(
  popoverProvider: any,
  props: any,
  popoverShow: any,
) {
  const {Consumer: PopoverConsumer} = popoverProvider;

  const renderReport = (reportProps: any) => {
    const {reportName} = props;
    const {popoverShow} = reportProps;

    const handleShowInfoPopover = (payload: any) =>
      popoverShow(InfoPopover, {
        ...payload,
        triggerRef: payload.triggerRef,
        useModal:
          Platform.OS === 'ios'
            ? !payload.isScreenReaderOn
            : Platform.OS === 'android',
      });

    if (reportName && reportName !== 'MY_TEAMS') {
      return (
        <ReportScreen
          {...reportProps}
          reportName={reportName}
          handleShowInfoPopover={handleShowInfoPopover}
        />
      );
    }

    return <MainScreen {...reportProps} />;
  };

  return ({navigation, route}: any) => {
    const handleOrderPressRef = useRef(({orderId}: any) => {
      navigate('client-profile-order-detail-screen', {
        orderId,
        modalName: ORDER_DETAILS,
      });
    });

    const {navigate} = navigation;

    const handleShowCreateCandidateRef = useRef(() =>
      navigate('create-candidate'),
    );

    const handleShowRecordRef = useRef((params = {}) =>
      navigate('records-record-screen', params),
    );

    const handleOrderPress =
      ({popoverHide, handleOrderPressRef}: any) =>
      async () => {
        await popoverHide();
        await handleOrderPressRef;
      };

    return (
      <PopoverConsumer>
        {({popoverShow, popoverHide}: any) =>
          renderReport({
            handleOrderPressRef,
            handleShowRecordRef,
            handleOrderPress,
            handleShowCreateCandidateRef,
            popoverShow,
            popoverHide,
            props,
            navigation,
            route,
          })
        }
      </PopoverConsumer>
    );
  };
}
